import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";            // UA
import HomePageRus from "./HomePage_Rus";     // RU
import PublicOffer from "./PublicOffer";
import PublicOfferRus from "./PublicOffer_Rus";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ru" element={<HomePageRus />} />
        <Route path="/oferta" element={<PublicOffer />} />
		<Route path="/ru/oferta" element={<PublicOfferRus />} />
      </Routes>
    </Router>
  );
}
